import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import sceneLogic from '~/scenes/homepage/logic'

export default function IntroBoxes () {
  const { startPage } = useValues(sceneLogic)
  const { box1, box2, box3 } = startPage || {}

  return (
    <div id='homepage-intro-boxes'>
      <div className='grid'>
        <div className='col-1-3'>
          {box1 ? <div className='widget noborder' dangerouslySetInnerHTML={{ __html: box1 }} /> : null}
        </div>
        <div className='col-1-3'>
          {box2 ? <div className='widget noborder' dangerouslySetInnerHTML={{ __html: box2 }} /> : null}
        </div>
        <div className='col-1-3'>
          {box3 ? <div className='widget noborder' dangerouslySetInnerHTML={{ __html: box3 }} /> : null}
        </div>
      </div>
    </div>
  )
}
